/**
 * @packageDocumentation
 * @module      P_Drive_Drive2.ts
 * @description Contains Emc related data for Drive 2
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import { toFixedDecimal } from "../utils";
export default class P_Drive_Drive2 {
    constructor() {
        this.vMotor = '0';
        this.vMotor36V = '0';
        this.vMotor12V = '0';
        this.vMotor5V = '0';
        this.vMotor3p3V = '0';
        this.RotTempEst = '0';
        this.LinTempEst = '0';
        this.LinVolMeas = '0';
        this.LinCurrent = '0';
        this.RotVolMeas = '0';
        this.RotCurrent = '0';
        this.LinErrorCode = '0';
        this.RotErrorCode = '0';
        this.LinStatus = '0';
        this.RotStatus = '0';
        this.RotPos = '0';
        this.RotVel = '0';
        this.LinEncPos = '0';
        this.LinVel = '0';
        this.ModuleDI = '0';
        this.vMotor5VLogic = '0';
        this.vMotor3VReference = '0';
        this.vMotor3VSecondReference = '0';
        this.vMotor2p5VOffset = '0';
        this.vMotor1p2VDspCore = '0';
        this.vMotorLEVSensedSupplyVoltage = '0';
    }
    static fromJSON(json) {
        if (json) {
            let p_Drive_Drive2 = new P_Drive_Drive2();
            if (json.vMotor) {
                p_Drive_Drive2.vMotor = toFixedDecimal(json.vMotor);
            }
            if (json.vMotor36V) {
                p_Drive_Drive2.vMotor36V = toFixedDecimal(json.vMotor36V);
            }
            if (json.vMotor12V) {
                p_Drive_Drive2.vMotor12V = toFixedDecimal(json.vMotor12V);
            }
            if (json.vMotor5V) {
                p_Drive_Drive2.vMotor5V = toFixedDecimal(json.vMotor5V);
            }
            if (json.vMotor3p3V) {
                p_Drive_Drive2.vMotor3p3V = toFixedDecimal(json.vMotor3p3V);
            }
            if (json.RotTempEst) {
                p_Drive_Drive2.RotTempEst = toFixedDecimal(json.RotTempEst);
            }
            if (json.LinTempEst) {
                p_Drive_Drive2.LinTempEst = toFixedDecimal(json.LinTempEst);
            }
            if (json.LinVolMeas) {
                p_Drive_Drive2.LinVolMeas = toFixedDecimal(json.LinVolMeas);
            }
            if (json.LinCurrent) {
                p_Drive_Drive2.LinCurrent = toFixedDecimal(json.LinCurrent);
            }
            if (json.RotVolMeas) {
                p_Drive_Drive2.RotVolMeas = toFixedDecimal(json.RotVolMeas);
            }
            if (json.RotCurrent) {
                p_Drive_Drive2.RotCurrent = toFixedDecimal(json.RotCurrent);
            }
            if (json.LinErrorCode) {
                p_Drive_Drive2.LinErrorCode = toFixedDecimal(json.LinErrorCode);
            }
            if (json.RotErrorCode) {
                p_Drive_Drive2.RotErrorCode = toFixedDecimal(json.RotErrorCode);
            }
            if (json.LinStatus) {
                p_Drive_Drive2.LinStatus = toFixedDecimal(json.LinStatus);
            }
            if (json.RotStatus) {
                p_Drive_Drive2.RotStatus = toFixedDecimal(json.RotStatus);
            }
            if (json.RotPos) {
                p_Drive_Drive2.RotPos = toFixedDecimal(json.RotPos);
            }
            if (json.RotVel) {
                p_Drive_Drive2.RotVel = toFixedDecimal(json.RotVel);
            }
            if (json.LinEncPos) {
                p_Drive_Drive2.LinEncPos = toFixedDecimal(json.LinEncPos);
            }
            if (json.LinVel) {
                p_Drive_Drive2.LinVel = toFixedDecimal(json.LinVel);
            }
            if (json.ModuleDI) {
                p_Drive_Drive2.ModuleDI = toFixedDecimal(json.ModuleDI);
            }
            if (json.vMotor5VLogic) {
                p_Drive_Drive2.vMotor5VLogic = toFixedDecimal(json.vMotor5VLogic);
            }
            if (json.vMotor3VReference) {
                p_Drive_Drive2.vMotor3VReference = toFixedDecimal(json.vMotor3VReference);
            }
            if (json.vMotor3VSecondReference) {
                p_Drive_Drive2.vMotor3VSecondReference = toFixedDecimal(json.vMotor3VSecondReference);
            }
            if (json.vMotor2p5VOffset) {
                p_Drive_Drive2.vMotor2p5VOffset = toFixedDecimal(json.vMotor2p5VOffset);
            }
            if (json.vMotor1p2VDspCore) {
                p_Drive_Drive2.vMotor1p2VDspCore = toFixedDecimal(json.vMotor1p2VDspCore);
            }
            if (json.vMotorLEVSensedSupplyVoltage) {
                p_Drive_Drive2.vMotorLEVSensedSupplyVoltage = toFixedDecimal(json.vMotorLEVSensedSupplyVoltage);
            }
            return p_Drive_Drive2;
        }
        return null;
    }
}
//# sourceMappingURL=P_Drive_Drive2.js.map